<div class="tvb-dialog-container">
  <i class="material-icons" (click)="onClose(false)">
    <img src="/assets/images/cancel.svg" aria-hidden="true" />
  </i>
  <div class="tvb-dialog-body">
    <div class="tvb-dialog-inner-body">
      <div class="title-info">
        <h3>The Real Deal</h3>
        <p>
          When you shop at The Vintage Bar all items are sent to our Copenhagen office first. This is so the items can
          go through extensive quality control before we send them to you. Quality control is handled by our team of
          brand experts, who check:
        </p>
        <ul>
          <li><span>The item’s authenticity and quality</span></li>
          <li>
            <span>The item’s condition and that it matches the sellers stated condition</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-info">
      <p>This way you don’t get any unwanted surprises.</p>
    </div>
  </div>
</div>
